import { useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { AIBedrock } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const useBedrockRegions = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["ai-bedrock-regions"],
    queryFn: () => defaultOnError(
      AIBedrock.regions(),
      i18n.t("notifications.aws_regions_load_message", { ns: "enterprise_ai" }),
      i18n.t("notifications.aws_regions_load_title", { ns: "enterprise_ai" })
    )
  });
  return { data: data != null ? data : [], isLoading };
};
export default useBedrockRegions;
